<template>
    <div>

        <el-button @click="callSpeakFunc">播放</el-button>

    </div>
</template>

<script>
/* eslint-disable */

export default {

    components: {},
    mounted() {
        this.startRecognition()
    },

    data() {
        return {
            time: null,
            title: "果洛藏族自治州草原一张图"
        };
    },
    methods: {
        speak(content, attr) {
            if ('speechSynthesis' in window) {
                const speech = new SpeechSynthesisUtterance(content.toString());
                speech.lang = attr.lang || 'zh-CN'; // 设置语言为中文
                speech.volume = attr.volume || 1;     // 设置音量
                speech.rate = attr.rate || 1;       // 设置语速
                speech.pitch = attr.pitch || 1;      // 设置音高
                // 监听开始播报
                speech.onstart = () => {
                };
                // 监听结束播报
                speech.onend = () => {
                };
                // 监听播报异常
                speech.onerror = () => {
                };
                window.speechSynthesis.speak(speech);
            } else {
                alert('您的浏览器不支持语音合成功能');
            }
        },

        // 调用语音播报函数
        callSpeakFunc() {
            console.log("播放--------------")
            let content = "安塞区草原一张图展示了安塞区草原的详细信息，包括资源状况、生态状况和有害生物状况。以下是所有信息的综合分析：资源状况：草地面积：59.61万亩，草地类型：7类28型，分别为：温性典型草原类：43.74万亩、暖性灌草丛类：4.68万亩、温性荒漠草原类：4.24万亩、暖性草丛类：3.34万亩、温性荒漠草丛类：3.15万亩。草原等级：2级草原：0.14万亩、3级草原：5.23万亩、4级草原：15.22万亩、5级草原：28.29万亩、6级草原：9.4万亩、7级草原：1.28万亩、8级草原：0.05万亩。生态状况：退化草原面积：17.65万亩、无退化：41.95万亩（70.39%）、轻度退化：13.77万亩（23.11%）、中度退化：3.22万亩（5.4%）、重度退化：0.66万亩（1.11%）。安塞区综合植被盖度为：59.83%，各个街道的综合植被盖度如下：白坪街道：61.39%、高武沟街道：61.92%、砖窑湾镇：61.61%、金明街道：64.55%、锁刀湾镇：45.17%、高桥镇：62.34%。草原有害生物状况常见有害鼠：3种，分别为中华鼢鼠、达乌尔黄鼠、达乌尔鼠兔。常见虫害：10种，分别为鼓翅皱膝螳等。常见毒害草：12种，分别为：地锦、大蓟、小蓬草、针叶黄华、杠柳。详细分析：资源丰富：安塞区的草地面积较大，类型多样，其中温性典型草原类占主导地位。生态问题：虽然大部分草地无退化，但仍有部分草地存在不同程度的退化问题，需要采取措施进行保护和恢复。有害生物：存在多种有害鼠、虫害和毒害草，对草原生态系统构成威胁，需要进行有效的防治。总结：安塞区的草原资源丰富，但面临一定的生态退化和有害生物问题。需要加强管理和保护措施，以维持草原生态系统的健康和稳定。具体措施可以包括：加强退化草原的恢复和治理。针对有害生物进行有效的防治。提高综合植被盖度，增强草原生态系统的稳定性。"
            let speakAttr = {
                lang: 'zh-CN',
                volume: 1,
                rate: 1,
                pitch: 1,
            }
            this.speak(content, speakAttr)
        },
        startRecognition() {
            if (window.SpeechRecognition || window.webkitSpeechRecognition) {
                const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
                const recognition = new SpeechRecognition();
                recognition.lang = 'zh-CN';
                recognition.onresult = (event) => {
                    this.recognizedText = event.results[0][0].transcript;
                    const transcript = event.results[0][0].transcript;
                    this.handleVoiceCommand(transcript);
                };
                recognition.onerror = (event) => {
                    console.error('识别出错：', event.error);
                };
                recognition.start();
            } else {
                alert('你的浏览器不支持语音识别功能');
            }


        },
        handleVoiceCommand(command) {
            if (command.substring(0, 3) == "草精灵") {
                
            }else if (command === "打开资源状况") {
                // 执行打开网站的操作
            } else if (command === "打开草原有害生物状况") {
                // 执行播放音乐的操作
            } else if (command === "打开生态状况") {
                // 执行播放音乐的操作
            } else if (command === "回到首页") {
                // 执行播放音乐的操作
            } else{
                
            }
        }

    }
};
</script>

<style lang="scss" scoped></style>